// Set page <title> and <meta name="description">.
import { useEffect } from "react";

export function useSeo({ title, description, path }) {
  useEffect(() => {
    if (title) document.title = `${title} · LandCalc India`;
    if (description) {
      let m = document.querySelector('meta[name="description"]');
      if (!m) { m = document.createElement("meta"); m.setAttribute("name","description"); document.head.appendChild(m); }
      m.setAttribute("content", description);
    }
    if (path) {
      let l = document.querySelector('link[rel="canonical"]');
      if (!l) { l = document.createElement("link"); l.setAttribute("rel","canonical"); document.head.appendChild(l); }
      l.setAttribute("href", `${window.location.origin}${path}`);
    }
  }, [title, description, path]);
}
